(function(){
"use strict";

var PROJECT_URL="https://ycentdpkspjdrzijrbsl.supabase.co";
var API_KEY="sb_publishable_TgKotXn3vvPpdnad_wXc9g_X1DY7arT";
var STORAGE_KEY="sb-ycentdpkspjdrzijrbsl-auth-token";
var running=false;
var timer=null;

function accessToken(){
  try{
    var raw=localStorage.getItem(STORAGE_KEY);
    if(!raw)return null;
    var v=JSON.parse(raw);
    return v&&v.access_token?v.access_token:null;
  }catch(e){return null;}
}
function esc(s){
  return String(s==null?"":s)
    .replace(/&/g,"&amp;").replace(/</g,"&lt;")
    .replace(/>/g,"&gt;").replace(/"/g,"&quot;")
    .replace(/'/g,"&#039;");
}
function sek(v){
  try{return new Intl.NumberFormat("sv-SE",{style:"currency",currency:"SEK",maximumFractionDigits:0}).format(Number(v||0));}
  catch(e){return Number(v||0)+" kr";}
}
async function rpc(name,body){
  var token=accessToken();
  if(!token)throw new Error("not-authenticated");
  var res=await fetch(PROJECT_URL+"/rest/v1/rpc/"+name,{
    method:"POST",
    headers:{
      "apikey":API_KEY,
      "Authorization":"Bearer "+token,
      "Content-Type":"application/json"
    },
    body:JSON.stringify(body||{})
  });
  if(!res.ok){
    var msg="";
    try{var j=await res.json();msg=j.message||j.error||"";}catch(e){}
    throw new Error(msg||("HTTP "+res.status));
  }
  return await res.json();
}
function removeInjected(id){
  var el=document.getElementById(id);
  if(el)el.remove();
}
function insertAfterHead(el){
  var content=document.querySelector(".content");
  if(!content)return false;
  var head=content.querySelector(".page-head");
  if(head&&head.nextSibling)content.insertBefore(el,head.nextSibling);
  else if(head)content.appendChild(el);
  else content.insertBefore(el,content.firstChild);
  return true;
}
function patchFinishHeadings(status){
  var content=document.querySelector(".content");
  if(!content)return;
  var hs=content.querySelectorAll("h3");
  hs.forEach(function(h){
    var txt=(h.textContent||"").trim();
    if(status==="review_pending"&&txt.indexOf("2. Betala Kampansera")===0){
      h.textContent="2. Kampansera granskar slutavräkningen";
    }
    if(status==="awaiting_payment"&&txt.indexOf("2. Kampansera granskar slutavräkningen")===0){
      h.textContent="2. Betala Kampansera";
    }
  });

  var buttons=content.querySelectorAll("button");
  buttons.forEach(function(b){
    if((b.textContent||"").trim()==="Jag har betalat Kampansera"){
      if(status==="review_pending"){
        b.disabled=true;
        b.textContent="Väntar på Kampanseras granskning";
      }
    }
  });

  var strongs=content.querySelectorAll("b,strong");
  strongs.forEach(function(el){
    var txt=(el.textContent||"").trim();
    if(status==="review_pending"&&txt==="Att betala till Kampansera"){
      el.textContent="Preliminärt belopp till Kampansera";
    }
  });
}
async function renderFinish(){
  if(location.hash!=="#/campaign-finish")return;
  var content=document.querySelector(".content");
  if(!content)return;

  var data=await rpc("get_campaign_payment_flow_v1",{});
  if(!data||!data.has_campaign||!data.allowed)return;

  patchFinishHeadings(data.settlement_status);
  removeInjected("settlement-flow-banner");

  var box=document.createElement("section");
  box.id="settlement-flow-banner";
  var st=String(data.settlement_status||"not_started");

  if(st==="review_pending"){
    box.className="settlement-flow-banner review";
    box.innerHTML='<div><h3>Väntar på Kampanseras granskning</h3><p>Försäljningen är avslutad. Kampansera kontrollerar order och slutavräkning innan betalningen öppnas. Du behöver inte betala något ännu.</p></div><div class="settlement-flow-amount">Preliminärt '+esc(sek(data.amount_due))+'</div>';
  }else if(st==="awaiting_payment"){
    box.className="settlement-flow-banner ready";
    box.innerHTML='<div><h3>Slutavräkningen är godkänd</h3><p>Betalningssteget är öppet. Betala enligt Kampanseras betalningsuppgifter och registrera därefter att betalningen är gjord.</p></div><div class="settlement-flow-amount">'+esc(sek(data.amount_due))+'</div>';
  }else if(st==="payment_reported"){
    box.className="settlement-flow-banner waiting";
    box.innerHTML='<div><h3>Betalningen är registrerad</h3><p>Kampansera stämmer nu av betalningen. När pengarna är bekräftade markeras kampanjen som helt slutförd.</p></div><div class="settlement-flow-amount">'+esc(sek(data.amount_due))+'</div>';
  }else if(st==="paid"){
    box.className="settlement-flow-banner done";
    box.innerHTML='<div><h3>Kampanjen är slutförd</h3><p>Betalningen är bekräftad av Kampansera och avslutet är klart.</p></div><div class="settlement-flow-amount">Klart ✓</div>';
  }else{
    return;
  }
  insertAfterHead(box);
}
async function approveSettlement(id,button){
  button.disabled=true;
  var old=button.textContent;
  button.textContent="Godkänner…";
  try{
    await rpc("admin_approve_campaign_settlement_v1",{p_campaign_id:id,p_note:"Godkänd i Kampansera admin"});
    button.textContent="Godkänd ✓";
    setTimeout(renderAdmin,400);
  }catch(e){
    button.disabled=false;
    button.textContent=old;
    window.alert("Kunde inte godkänna slutavräkningen: "+e.message);
  }
}
async function renderAdmin(){
  if(location.hash!=="#/admin")return;
  var content=document.querySelector(".content");
  if(!content)return;

  var rows=await rpc("admin_list_settlement_reviews_v1",{});
  removeInjected("settlement-admin-reviews");
  if(!Array.isArray(rows)||!rows.length)return;

  var card=document.createElement("section");
  card.id="settlement-admin-reviews";
  card.className="card card-pad settlement-admin-card";

  var html='<div class="card-title">Slutavräkningar att granska</div><div class="card-sub">Godkänn först när order och belopp är kontrollerade. Då öppnas betalningen för gruppansvarig.</div><div class="divider"></div>';
  rows.forEach(function(r){
    html+='<div class="settlement-admin-row"><div><b>'+esc(r.group_name)+'</b><div class="settlement-admin-meta">'+esc(r.campaign_name)+' · '+esc(String(r.order_count))+' order</div></div><div class="settlement-flow-amount">'+esc(sek(r.amount_due))+'</div><button class="btn btn-primary btn-sm js-settlement-approve" data-id="'+esc(r.campaign_id)+'" type="button">Godkänn slutavräkning</button></div>';
  });
  card.innerHTML=html;

  var head=content.querySelector(".page-head");
  if(head&&head.nextSibling)content.insertBefore(card,head.nextSibling);
  else content.insertBefore(card,content.firstChild);

  card.querySelectorAll(".js-settlement-approve").forEach(function(b){
    b.addEventListener("click",function(){approveSettlement(b.dataset.id,b);});
  });
}
async function run(){
  if(running)return;
  running=true;
  try{
    if(location.hash==="#/campaign-finish")await renderFinish();
    else if(location.hash==="#/admin")await renderAdmin();
    else{
      removeInjected("settlement-flow-banner");
      removeInjected("settlement-admin-reviews");
    }
  }catch(e){
    if(e.message!=="not-authenticated")console.warn("Settlement flow:",e.message);
  }finally{running=false;}
}
function schedule(){
  clearTimeout(timer);
  timer=setTimeout(run,180);
}
window.addEventListener("hashchange",schedule);
window.addEventListener("focus",schedule);
document.addEventListener("visibilitychange",function(){if(!document.hidden)schedule();});
var app=document.getElementById("app");
if(app&&window.MutationObserver){
  new MutationObserver(function(){
    if(location.hash==="#/campaign-finish"&&!document.getElementById("settlement-flow-banner"))schedule();
    if(location.hash==="#/admin"&&!document.getElementById("settlement-admin-reviews"))schedule();
  }).observe(app,{childList:true,subtree:true});
}
setInterval(schedule,30000);
schedule();
})();